// MobileDrawer.jsx
import { X, ChevronDown } from "lucide-react";
import {
  navLinks,
  registrationServices,
  serviceCategories,
  advisoryServices
} from "./navData";

export default function MobileDrawer({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 lg:hidden z-50" onClick={onClose}>
      <div
        className="w-80 h-full bg-white text-black p-6 flex flex-col overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-8">
          <h2 className="text-2xl font-bold">Menu</h2>
          <button onClick={onClose}>
            <X size={24} />
          </button>
        </div>

        <nav className="flex-1 space-y-4">
          {navLinks.map((link) => (
            <div key={link.name}>
              {link.path ? (
                <a
                  href={link.path}
                  className="block py-3 px-4 rounded-lg hover:bg-yellow-50 font-medium"
                  onClick={onClose}
                >
                  {link.name}
                </a>
              ) : (
                <details className="group">
                  <summary className="list-none py-3 px-4 rounded-lg hover:bg-yellow-50 font-medium cursor-pointer flex items-center justify-between">
                    {link.name}
                    <ChevronDown
                      size={20}
                      className="group-open:rotate-180 transition-transform"
                    />
                  </summary>
                  <div className="ml-4 mt-2 space-y-2">
                    {link.dropdown === "registration" &&
                      registrationServices.map((cat) => (
                        <details key={cat.name} className="group/sub">
                          <summary className="list-none py-2 px-4 text-sm rounded-lg hover:bg-yellow-50 cursor-pointer">
                            {cat.name}
                          </summary>
                          <div className="ml-4 mt-1 space-y-1">
                            {cat.subItems.map((item) => (
                              <a
                                key={item.name}
                                href={item.path}
                                className="block py-1 px-4 text-xs hover:bg-yellow-100 rounded"
                                onClick={onClose}
                              >
                                {item.name}
                              </a>
                            ))}
                          </div>
                        </details>
                      ))}

                    {link.dropdown === "services" &&
                      serviceCategories.map((cat) => (
                        <details key={cat.name} className="group/sub">
                          <summary className="list-none py-2 px-4 text-sm rounded-lg hover:bg-yellow-50 cursor-pointer">
                            {cat.name}
                          </summary>
                          <div className="ml-4 mt-1 space-y-1">
                            {cat.subItems.map((item) => (
                              <a
                                key={item.name}
                                href={item.path}
                                className="block py-1 px-4 text-xs hover:bg-yellow-100 rounded"
                                onClick={onClose}
                              >
                                {item.name}
                              </a>
                            ))}
                          </div>
                        </details>
                      ))}

                    {link.dropdown === "advisory" &&
                      advisoryServices.map((item) => (
                        <a
                          key={item.name}
                          href={item.path}
                          className="block py-2 px-4 text-sm hover:bg-yellow-100 rounded"
                          onClick={onClose}
                        >
                          {item.name}
                        </a>
                      ))}
                  </div>
                </details>
              )}
            </div>
          ))}
        </nav>
      </div>
    </div>
  );
}
